import styled from "styled-components";
import { DashboardIcon } from "./icons/pages/DashboardIcon";
import { FAQIcon } from "./icons/pages/FAQIcon";
import { PlayIcon } from "./icons/pages/PlayIcon";
import { PoolsIcon } from "./icons/pages/PoolsIcon";
import { ReferralsIcon } from "./icons/pages/ReferralsIcon";

import { BarsIcon } from "./icons/pages/BarsIcon";
import { GearIcon } from "./icons/pages/GearIcon";
import { GetBrkEthIcon } from "./icons/pages/GetBrkEthIcon";
import { GlobalTrendsIcon } from "./icons/pages/GlobalTrendsIcon";
import { InvestIcon } from "./icons/pages/InvestIcon";
import { EthIcon } from "./icons/tokens/Eth";
import { StrategyIcon } from "./icons/pages/StrategyIcon";
import { AtIcon } from "./icons/AtIcon";
import { CrossCircleIcon } from "./icons/CrossCircleIcon";
import { ShieldCheckIcon } from "./icons/ShieldCheckIcon";
import { ChevronLeftIcon } from "./icons/ChevronLeftIcon";
import { GuardianLogoIcon } from "./icons/GuardianLogoIcon";
import { ColorDeclaration, } from "@bracket/ui/types";
import { getTheme, } from "@bracket/ui/themes";


export type IconName =
  | "page-settings"
  | "page-dashboard"
  | "page-faq"
  | "page-pools"
  | "page-referrals"
  | "page-play"
  | "page-bars"
  | "page-get-brk-eth"
  | "page-global-trends"
  | "page-invest"
  | "token-eth"
  | "page-strategy"
  | "at"
  | "cross-circle"
  | "shield-check"
  | "chevron-left"
  | "guardian-logo";

interface IconProps {
  name: IconName;
  height?: number;
  width?: number;
  className?: string;
  color?: ColorDeclaration | keyof ReturnType<typeof getTheme>;
	inflexible?: boolean;
}


const iconComponents = {
  "page-settings": GearIcon,
  "page-dashboard": DashboardIcon,
  "page-faq": FAQIcon,
  "page-pools": PoolsIcon,
  "page-referrals": ReferralsIcon,
  "page-play": PlayIcon,
  "page-bars": BarsIcon,
  "page-get-brk-eth": GetBrkEthIcon,
  "page-global-trends": GlobalTrendsIcon,
  "page-invest": InvestIcon,
  "token-eth": EthIcon,
  "page-strategy": StrategyIcon,
  at: AtIcon,
  "cross-circle": CrossCircleIcon,
  "shield-check": ShieldCheckIcon,
  "chevron-left": ChevronLeftIcon,
  "guardian-logo": GuardianLogoIcon,
} as const;

export const Icon = ({
  name,
  height = 20,
  width = 20,
  className,
  color,
	inflexible,
}: IconProps) => {
  const IconComponent = iconComponents[name];

  return (
		<SvgFrame $inflexible={inflexible}> 
			<StyledSvg
				width={width}
				height={height}
				viewBox={`0 0 ${width} ${height}`}
				fill="currentColor"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
				color={color}
			>
				<IconComponent />
			</StyledSvg>
		</SvgFrame>
  );
};

const SvgFrame = styled.div<{ height?: number; width?: number; $inflexible?: boolean; }>`
	display: flex;
	align-items: center;
	justify-content: center;
	${({ $inflexible }) => !$inflexible && "flex: 1;"}
	max-width: 100%;
	max-height: 100%;
`

// @ts-ignore : this is a valid type assertion
const StyledSvg = styled.svg<Omit<IconProps, "name">>`color: ${({ color, }) => color ? color in getTheme() ? getTheme()[color] : color : getTheme().subheading};`;
